import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useConfirm } from "material-ui-confirm";
import { useBeforeunload } from "react-beforeunload";
import { Card } from "@mui/material";

import { isCorrectAnswer } from "../../../helpers";
import { handleExitGame } from "../../../helpers/handleExitGame";
import MultipleChoice from "./MultipleChoice";
import TypeAnswer from "./TypeAnswer";
import GameHeader from "../GameHeader";
import GameResults from "../GameResults";
import { ACCEPTED_COUNTRY_NAMES } from "../../../data/ACCEPTED_COUNTRY_NAMES";
import { ACCEPTED_COUNTRY_CAPITALS } from "../../../data/ACCEPTED_COUNTRY_CAPITALS";

const FlagsAndCapitals = ({ game }) => {
  useBeforeunload((e) => e.preventDefault());
  const confirm = useConfirm();
  const dispatch = useDispatch();

  const [score, setScore] = useState(0);
  const [progress, setProgress] = useState(1);
  const [open, setOpen] = useState(false);

  const COUNTRY_DATA = useSelector((state) => state.game.game.countryData);

  const handleSubmitAnswer_MC = (inputValue, country) => {
    let correct =
      game.title === "Flags"
        ? inputValue === country.name
        : inputValue === country.capital;

    let correctChoice = document.getElementById("correct");
    correctChoice.style.backgroundColor = "#729601";

    setTimeout(
      () => {
        correctChoice.style.backgroundColor = "#fcfff3";
        setScore(score + (correct ? 1 : 0));
        if (progress >= game.questions) {
          setOpen(true);
          return;
        }
        setProgress(progress + 1);
      },
      correct ? 500 : 1000
    );
  };

  const handleSubmitAnswer_Input = (
    inputValue,
    country,
    inputBox,
    setInputValue
  ) => {
    let correct = isCorrectAnswer(inputValue, country, game.title);
    let validAnswer =
      game.title === "Flags"
        ? ACCEPTED_COUNTRY_NAMES.includes(inputValue)
        : ACCEPTED_COUNTRY_CAPITALS.includes(inputValue);
    if (!correct && !validAnswer) {
      return;
    }

    inputBox.style.border = `2px solid ${correct ? "#729601" : "#da121a"}`;
    inputBox.value = game.title === "Flags" ? country.name : country.capital;

    setTimeout(
      () => {
        inputBox.style.border = "2px solid transparent";
        setInputValue("");
        setScore(score + (correct ? 1 : 0));
        if (progress >= game.questions) {
          setOpen(true);
          return;
        }
        setProgress(progress + 1);
      },
      correct ? 500 : 1000
    );
  };

  return (
    <>
      <Card
        sx={{
          width: "90%",
          backgroundColor: "background.paper",
          margin: "auto",
          padding: "0 5px",
          maxWidth: "700px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
        elevation={5}
      >
        <GameHeader
          score={score}
          progress={progress}
          totalQuestions={game.questions}
          handleExitGame={() => {
            handleExitGame(confirm, dispatch);
          }}
        />
        {game.mode === "Multiple Choice" ? (
          <MultipleChoice
            country={COUNTRY_DATA[progress - 1]}
            handleSubmitAnswer_MC={handleSubmitAnswer_MC}
            gameTitle={game.title}
          />
        ) : (
          <TypeAnswer
            country={COUNTRY_DATA[progress - 1]}
            handleSubmitAnswer_Input={handleSubmitAnswer_Input}
            gameTitle={game.title}
          />
        )}
      </Card>
      <GameResults open={open} setOpen={setOpen} game={game} score={score} />
    </>
  );
};

export default FlagsAndCapitals;
